"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_1 = require("@mdi/js");
var react_1 = require("@mdi/react");
var react_2 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var auth_1 = require("react-firebase-hooks/auth");
var react_router_1 = require("react-router");
var App_1 = require("../../App");
var Footer = function () {
    var logic = (0, App_1.useEloise)().logic;
    var _a = (0, auth_1.useAuthState)(logic.fb.auth), user = _a[0], loading = _a[1], error = _a[2];
    var pathName = (0, react_router_1.useLocation)().pathname;
    var navigate = (0, react_router_1.useNavigate)();
    var theme = (0, App_1.useEloise)().theme;
    var handleCogClick = function () {
        navigate(pathName, { state: { sideWidget: "Login" } });
        // Your settings cog onClick logic here
    };
    var handleChatClick = function () {
        if (user) {
            navigate(pathName, { state: { sideWidget: "Eloise" } });
        }
        else {
            navigate(pathName, { state: { sideWidget: "Login" } });
        }
        // Your chat onClick logic here
    };
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(react_bootstrap_1.Navbar, { expand: "lg", style: {
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: "transparent", // Semi-transparent black background
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
            } },
            react_2.default.createElement(react_bootstrap_1.Container, { fluid: true },
                react_2.default.createElement("div", { onClick: handleCogClick, style: { cursor: "pointer" } },
                    react_2.default.createElement(react_1.Icon, { path: js_1.mdiCogOutline, size: 1.5, color: theme.colors[0] })),
                react_2.default.createElement("div", { onClick: handleChatClick, style: { cursor: "pointer" } },
                    react_2.default.createElement(react_1.Icon, { path: js_1.mdiChat, size: 1.5, color: theme.colors[0] }))))));
};
exports.default = Footer;
